import { confirmEmail, updateToken } from 'api/users/users';
import withContainer from 'components/Container/withContainer';
import Skeleton from 'components/Skeleton/Skeleton';
import { ResponseCodes } from 'helpers/constants';
import { RouterPaths } from 'helpers/router-paths';
import useUpdateEffect from 'hooks/useUpdateEffect';
import { useMemo, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { FetchError } from 'typings/fetch';
import { BigHeadline, CenterContainer, TextLNormal } from 'ui/Styled/Styled';

const ConfirmEmailPage = () => {
    const [params] = useSearchParams();

    const token = useMemo(() => params.get('token'), [params]);

    const [loading, setLoading] = useState(true);
    const [secondsToRedirect, setSecondsToRedirect] = useState(5);
    const [error, setError] = useState<FetchError>();
    const navigate = useNavigate();

    const intervalRef = useRef<NodeJS.Timer>();

    useUpdateEffect(() => {
        if (token) {
            confirmEmail(token)(async () => {
                await updateToken();

                setLoading(false);

                if (!intervalRef.current) {
                    intervalRef.current = setInterval(() => {
                        setSecondsToRedirect((val) => Math.max(val - 1, 0));
                    }, 1000);
                }
            }, setError);

            return () => clearInterval(intervalRef.current);
        }
    }, [token]);

    useUpdateEffect(() => {
        if (secondsToRedirect === 0) {
            navigate(RouterPaths.Home);
        }
    }, [secondsToRedirect, navigate]);

    if (loading && token && !error) {
        return <Skeleton />;
    }

    const isExpired = error?.code === ResponseCodes.ExpiredEmailToken;

    return (
        <CenterContainer>
            {token && !error ? (
                <>
                    <BigHeadline>E-mail успешно подтвержден</BigHeadline>
                    <TextLNormal>
                        Переадресация на главную через {secondsToRedirect}...
                    </TextLNormal>
                </>
            ) : (
                <>
                    <BigHeadline>
                        {isExpired
                            ? 'Ссылка устарела'
                            : 'Ссылка недействительна'}
                    </BigHeadline>
                    <TextLNormal>
                        {isExpired
                            ? 'Вам отправлено новое письмо с ссылкой для подтверждения. Откройте его и перейдите по ссылке.'
                            : 'Проверьте ссылку и повторите попытку'}
                    </TextLNormal>
                </>
            )}
        </CenterContainer>
    );
};

export default withContainer(ConfirmEmailPage, { checkEmailConfirm: false });
